import Image from 'app/Components/Shared/Image/image';
import React, {useMemo} from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import InfoPanel from '../InfoDeliveryForm/SubComponents/InfoPanel/InfoPanel';
import {isValidObject} from '../../../Assets/functions/functions';

const OverviewPanel = ({icon, title, subtitle, infoPanelObj, btnText, btnOnClick}) => {
  const isInfoPaneObjValid = useMemo(() => {
    return isValidObject(infoPanelObj);
  }, [infoPanelObj]);

  return (
    <div className='overview-panel-container'>
      <div className='overview-panel'>
        <div className='overview-top-panel'>
          {icon && <Image className='overview-panel-icon' src={icon} />}
          <div className='titles-area'>
            {title && <span className='overview-panel-title'>{title}</span>}
            {subtitle && <span className='overview-panel-subtitle'>{subtitle}</span>}
          </div>
          {isInfoPaneObjValid && <InfoPanel {...infoPanelObj} />}
        </div>
        {btnText && <BtnSubmit text={btnText} onclick={btnOnClick} />}
      </div>
    </div>
  );
};

export default OverviewPanel;
